import { Variants } from 'src/lib'
import { useConfig } from '@context/ConfigurationContext'

export const useIsCityVariant = () => {
  const { variant } = useConfig()
  return variant?.type === Variants.City && !!variant.cityName
}
